/**
 * Notification type constants and utilities
 * Centralized definition of notification types for consistency
 */

export const NOTIFICATION_TYPES = {
  NEW_CHAT: 'NEW_CHAT',
  SYSTEM_ALERT: 'SYSTEM_ALERT',
  SERVICE_STATUS: 'SERVICE_STATUS',
  BROADCAST: 'BROADCAST',
  REGISTER: 'REGISTER',
  HEARTBEAT: 'HEARTBEAT'
};

export const PRIORITY_LEVELS = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  URGENT: 'URGENT'
};

/**
 * Check if notification type requires user attention
 * @param {string} type Notification type
 * @returns {boolean} True if notification requires attention
 */
export function requiresAttention(type) {
  return [
    NOTIFICATION_TYPES.NEW_CHAT,
    NOTIFICATION_TYPES.SYSTEM_ALERT,
    NOTIFICATION_TYPES.SERVICE_STATUS
  ].includes(type);
}

/**
 * Get notification priority level
 * @param {string} priority Priority string
 * @returns {number} Priority level (0-3)
 */
export function getPriorityLevel(priority) {
  const levels = {
    [PRIORITY_LEVELS.LOW]: 0,
    [PRIORITY_LEVELS.MEDIUM]: 1,
    [PRIORITY_LEVELS.HIGH]: 2,
    [PRIORITY_LEVELS.URGENT]: 3
  };
  return levels[priority] || 1;
}

